<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path fill-rule="evenodd" d="M8.94 8.94A1.5 1.5 0 0110 8.5h20a1.5 1.5 0 010 3H13.621l25.44 25.44a1.5 1.5 0 01-2.122 2.12L11.5 13.622V30a1.5 1.5 0 01-3 0V10c0-.398.158-.78.44-1.06z"/></svg>